module.exports = __webpack_public_path__ + "img/60.70c44e6f.jpg";